module.exports = __webpack_public_path__ + "img/feature_buy_zh.8f8ba564.png";